module.exports = __webpack_public_path__ + "static/media/HealthIcon.a7b2000e.svg";